import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

// private route
const PrivateRoute = ({ children }) => {
  const user = useSelector(state => state.auth.user);

  const isAuthenticated = () => {
    if (user?.data?.token || user?.token) return true;

    const storedUser = localStorage.getItem("useralbaraqawy");
    if (storedUser) {
      try {
        const parsed = JSON.parse(storedUser);
        return Boolean(
          parsed?.token ||
          parsed?.data?.token ||
          parsed?.user?.token ||
          parsed?.result?.token,
        );
      } catch {
        return false;
      }
    }
    return false;
  };

  return isAuthenticated() ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;
